import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Grid, Segment, Checkbox, List, Icon, Button } from 'semantic-ui-react'
//import { useDispatch } from 'react-redux'
// import dataGroup from './dataGroup'
import styled from 'styled-components'
import { ModalTemplate } from 'Utils/reactTable/components/ModalTemplate'
import { saveColumnsPreference } from 'Store/actions/login-action'
/*  Author: Bruno Melo
    Type: SmartS
	Description: Content of Columns Actions;			 
	To do list: -
				
*/

const CheckBoxCapitalized = styled(Checkbox)`
  .checkbox label {
    text-transform: capitalize;
  }
`
const StyledSegment = styled(Segment)`
   {
    height: 60vh;
    overflow: auto;
  }
`

export const ColumnsReactTable = ({ columnsOpen, setColumnsOpen, t, table, columnsStr, allTableProps }) => {
  // temporary copy of data just for the list display
  // only change the actual columns after saving
  const [checkListColumns, setCheckListColumns] = React.useState([])
  const hiddenColumns = checkListColumns.filter((c) => !c.isVisible).map((c) => c.id)
  // used to display save message when needed
  const [oneColumnChecked, setOneColumnChecked] = React.useState(true)

  useEffect(() => {
    const columns = JSON.parse(columnsStr)
    if (columnsOpen) {
      setCheckListColumns(
        columns.map((c) => {
          return {
            id: c.id,
            isVisible: c.isVisible,
          }
        })
      )
    }
  }, [columnsOpen, columnsStr])

  const columns = JSON.parse(columnsStr)

  const dispatch = useDispatch()

  const handleToggle = (checkmark) => {
    setCheckListColumns(
      checkListColumns.map((c) => {
        return { id: c.id, isVisible: checkmark }
      })
    )
  }

  const checkAtLeastOne = (columns) => {
    const atLeastOneColumn = columns.filter((c) => c.isVisible)
    return atLeastOneColumn.length > 0 ? true : false
  }

  const handleCheck = (id, checked) => {
    // update local state
    setCheckListColumns(
      checkListColumns.map((c) => {
        if (c.id === id) {
          // isVisible is the inverse of current checked (toggled)
          return { id: c.id, isVisible: !checked }
        } else {
          return c
        }
      })
    )
  }

  const handleSave = () => {
    const columnCondition = checkAtLeastOne(checkListColumns)

    // requires at least one column displayed to save
    if (columnCondition) {
      dispatch(saveColumnsPreference(table, hiddenColumns, false))
      setColumnsOpen(false)
      // update the original columns
      allTableProps.setHiddenColumns(checkListColumns.filter((clc) => !clc.isVisible).map((c) => c.id))
    }

    setOneColumnChecked(columnCondition)
  }

  return (
    <ModalTemplate
      onClose={() => setColumnsOpen(false)}
      open={columnsOpen}
      size="small"
      header={t('allColumnsAvailable')}
      onSave={handleSave}
      onCancel={() => setColumnsOpen(false)}
    >
      {columns.length === 0 ? (
        <p>{t('noColumns')}</p>
      ) : (
        <>
          <Grid columns={1}>
            <Grid.Column key={'col.' + table}>
              <Button
                primary
                style={{ background: '#4b72b2' }}
                content={t('ToggleAll')}
                size="small"
                onClick={() => handleToggle(true)}
                icon="check square outline"
              />
              <Button
                secondary
                content={t('UntoggleAll')}
                size="small"
                onClick={() => handleToggle(false)}
                icon="square outline"
              />
              <StyledSegment key={'seg.' + table}>
                <List key={'list.' + table}>
                  <List.Header>
                    <Icon name={'columns'} />
                    {t(table)}
                  </List.Header>

                  {checkListColumns.map((column) => {
                    // get the checked status
                    const checked = checkListColumns.find((each) => each.id === column.id).isVisible
                    return (
                      column && (
                        <List.Item
                          key={'li' + table + '.' + column.id}
                          onClick={() => {
                            handleCheck(column.id, checked)
                          }}
                        >
                          <CheckBoxCapitalized
                            label={t(column.id)}
                            id={column.id}
                            checked={checked}
                            onChange={(e, data) => {
                              handleCheck(data.id, checked)
                            }}
                          />
                        </List.Item>
                      )
                    )
                  })}
                </List>
              </StyledSegment>
            </Grid.Column>
          </Grid>

          <br />

          {!oneColumnChecked ? (
            <Segment inverted color="red">
              {t('atLeastOneColumnRequired')}
            </Segment>
          ) : (
            ''
          )}
        </>
      )}
    </ModalTemplate>
  )
}

export default ColumnsReactTable
